<list-view [liste]="listeAbattements" *ngIf="listeAbattements"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>
